<template>
  <div class="makercart-hero-section" :style="heroBgStyle">
    <div class="hero-container">
      <!-- Left side - Illustration -->
      <div class="hero-illustration">
        <div class="illustration-card">
          <img
            src="/images/maker-cart/makercart-catalog-illustration.svg"
            alt="Makercart Catalog"
            class="catalog-image"
          />
        </div>
      </div>

      <!-- Right side - Content -->
      <div class="hero-content">
        <h1 class="hero-title">Build Your Makercart</h1>
        <p class="hero-subtitle">
          Choose from hundreds of classroom-ready, hands-on activities.
        </p>
      </div>
    </div>

    <div class="hero-container-mobile">
      <h1 class="mobile-hero-title">Build Your Makercart</h1>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

// Background images for hero section provided via CSS variables to avoid CSS-loader resolution issues
const heroBgStyle = computed(() => ({
  "--hero-bg": "url('/images/maker-cart/hero-banner.svg')",
  "--hero-bg-mobile": "url('/images/maker-cart/hero-banner-mobile.svg')",
}));
</script>
<style scoped>
/* Makercart Hero Section Styles */
.hero-container-mobile {
  display: none;
}

.makercart-hero-section {
  background: #00925e;
  padding: 20px 40px;
  border-radius: 0px 0px 64px 64px;
  position: relative;
  overflow: hidden;
}

.makercart-hero-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--hero-bg) no-repeat center center;
  background-size: cover;
  opacity: 1;
  z-index: 0;
}

.hero-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  padding: 24px;
}

.hero-illustration {
  flex: 0 0 auto;
}

.illustration-card {
  background: #f2f3fb;
  backdrop-filter: blur(0.603px);
  border-radius: 12px;
  width: 261px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.catalog-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.hero-content {
  flex: 1;
  background: #ffffff;
  padding: 16px;
  border-radius: 16px;
  color: var(--primary-blue);
}

.hero-title {
  font-family: "League Spartan", sans-serif;
  font-weight: 700;
  font-size: 57px;
  line-height: 64px;
  letter-spacing: -0.1425px;
  margin: 0 0 4px 0;
  color: var(--primary-blue);
}

.hero-subtitle {
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  font-size: 32px;
  line-height: 40px;
  margin: 0;
  color: var(--primary-blue);
}

/* Responsive Design */
@media (max-width: 768px) {
  .makercart-hero-section {
    padding: 20px;
    border-radius: 0px 0px 35px 0px;
  }

  .hero-container {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .illustration-card {
    width: 100%;
    max-width: 300px;
    height: auto;
    min-height: 120px;
  }

  .hero-content {
    width: 100%;
  }

  .hero-title {
    font-size: 36px;
    line-height: 42px;
  }

  .hero-subtitle {
    font-size: var(--fs-big);
    line-height: 28px;
  }

  .makercart-hero-section::before {
    background-image: var(--hero-bg-mobile);
  }
}

@media (max-width: 480px) {
  .hero-container-mobile {
    display: flex;
    position: relative;
    padding: 40px 0px;
  }

  .mobile-hero-title {
    font-size: var(--fs-xxl);
    line-height: 34px;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: 0%;
    color: #ffffff;
  }

  .hero-title {
    font-size: var(--fs-xxl);
    line-height: 34px;
  }

  .hero-subtitle {
    font-size: 18px;
    line-height: 24px;
  }

  .makercart-hero-section {
    border-radius: 0px;
  }

  .hero-container {
    display: none;
  }
}
</style>
